import { useState } from 'react';
import { useGetProgramMembers, type ProgramMember } from '../api/useProgram';
import { DataTable, type Column } from './DataTable';
import { Pagination } from './Pagination';

const PAGE_SIZE = 10;

const columns: Column<ProgramMember>[] = [
  { key: 'uid', header: 'Member ID', className: 'font-mono text-xs text-gray-400', cell: (m) => `${m.uid.slice(0, 8)}…`, copyValue: (m) => m.uid },
  { key: 'name', header: 'Name', className: 'text-gray-900', cell: (m) => m.name, copyValue: (m) => m.name },
  { key: 'email', header: 'Email', cell: (m) => m.email, copyValue: (m) => m.email },
  { key: 'phone', header: 'Phone', cell: (m) => m.phone, copyValue: (m) => m.phone },
  { key: 'spend', header: 'Spend', className: 'text-gray-900', cell: (m) => m.spend },
  { key: 'balance', header: 'Balance', cell: (m) => m.balance },
  {
    key: 'status',
    header: 'Status',
    cell: (m) => (
      <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${m.active ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-600'}`}>
        {m.active ? 'Active' : 'Inactive'}
      </span>
    ),
  },
];

export const ProgramGuestsTable = ({ uid }: { uid: string }) => {
  const [page, setPage] = useState(0);
  const { data, isLoading, isError } = useGetProgramMembers(uid, { page, limit: PAGE_SIZE });

  const members = data?.payload?.members ?? [];
  const total = data?.payload?.total ?? 0;
  const showPagination = !isLoading && !isError && members.length > 0;

  return (
    <div className="flex flex-col gap-4">
      <DataTable
        columns={columns}
        rows={members}
        rowKey={(m) => m.uid}
        isLoading={isLoading}
        isError={isError}
        errorLabel="Failed to load members."
        emptyLabel="No members."
      />
      {showPagination && (
        <Pagination page={page} pageSize={PAGE_SIZE} total={total} onPageChange={setPage} />
      )}
    </div>
  );
};
